import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './../messages/lang'
import store from '@/store/index'
import api from '@/api/api'

const locale = localStorage.getItem('locale')

Vue.use(VueI18n)

const i18n = new VueI18n({
	// locale: store.getters.getLocale, // set locale
	fallbackLocale: 'en',
	messages: {}	 // set locale messages
})

const loadedLanguages = ['en'] // our default language that is preloaded

export function setI18nLanguage (lang) {
    i18n.locale = lang
    localStorage.setItem('locale', lang)
}

export async function getTranslations () {
	await api.fetchRenderTranslations()
	.then((res) => {
		i18n.setLocaleMessage('en', res.data.en)
		i18n.setLocaleMessage('cg', res.data.cg)
	})
	return true
}
export default i18n


// WEBPACK FOOTER //
// ./src/i18n/setup/i18n-setup.js